import Vue from 'vue'
import VueRouter from 'vue-router'
// import index from '../views/index.vue'
// import home from '../views/home.vue'
// import hardware from '../views/hardware/hardware.vue'
// import instrument from '../views/software/instrument/index.vue'
// import danger from '../views/software/danger/index.vue'
// import animal from '../views/software/animal/index.vue'
// import shareSystem from '../views/software/shareSystem/index.vue'
// import safetySystem from '../views/software/safetySystem/index.vue'
// import union from '../views/union/union.vue'
// import aboutUs from '../views/aboutUs/aboutUs.vue'
// import afterSale from '../views/afterSale/afterSale.vue'
// import customerCase from '../views/customer/case/index.vue'
// import newsList from '../views/news/newsList/index.vue'
// import newsDetail from '../views/news/newsDetail/index.vue'
Vue.use(VueRouter)

const routes = [
	
  {
    path: '/',
    name: 'index',
    component: () => import('@/views/index.vue'),
	redirect:'/home',
	meta:{
		title:"广州市科颐轩电子科技有限公司官网",
	},
	 children: [
	        {
	          path: '/home',
			  name:'home',
	          component: () => import('@/views/home.vue'),
			  meta:{
			  	title:"广州市科颐轩电子科技有限公司官网",
			  },
	        },
			{
			  path: '/hardware',
			  name:'hardware',
			  component: () => import('@/views/hardware/hardware.vue'),
			  // component:hardware,
			  meta:{
			  	// title:"智能硬件",
				title:"广州市科颐轩电子科技有限公司官网",
			  },
			},
			{
			  path: '/software/instrument',
			  name:'instrument',
			  component: () => import('@/views/software/instrument/index.vue'),
			  meta:{
			  	// title:"仪器管理系统",
				title:"广州市科颐轩电子科技有限公司官网",
			  },
			},
			{
			  path: '/software/danger',
			  name:'danger',
			  component: () => import('@/views/software/danger/index.vue'),
			  meta:{
			  	// title:"危化品管理系统",
				title:"广州市科颐轩电子科技有限公司官网",
			  },
			},
			{
			  path: '/software/animal',
			  name:'animal',
			  component: () => import('@/views/software/animal/index.vue'),
			  meta:{
			  	// title:"动物房安全系统",
				title:"广州市科颐轩电子科技有限公司官网",
			  },
			},
			{
			  path: '/software/shareSystem',
			  name:'shareSystem',
			  component: () => import('@/views/software/shareSystem/index.vue'),
			  meta:{
			  	// title:"共享支持系统",
				title:"广州市科颐轩电子科技有限公司官网",
			  },
			},
			{
			  path: '/software/safetySystem',
			  name:'safetySystem',
			  component: () => import('@/views/software/safetySystem/index.vue'),
			  meta:{
			  	// title:"实验室安全系统",
				title:"广州市科颐轩电子科技有限公司官网",
			  },
			},
			{
			  path: '/union/union',
			  name:'union',
			  component: () => import('@/views/union/union.vue'),
			  meta:{
			  	// title:"中科联盟",
				title:"广州市科颐轩电子科技有限公司官网",
			  },
			},
			{
			  path: '/aboutUs/aboutUs',
			  name:'aboutUs',
			  component: () => import('@/views/aboutUs/aboutUs.vue'),
			  meta:{
			  	title:"广州市科颐轩电子科技有限公司官网",
			  },
			},
			{
			  path: '/afterSale/afterSale',
			  name:'afterSale',
			  component: () => import('@/views/afterSale/afterSale.vue'),
			  meta:{
			  	// title:"产品售后",
				title:"广州市科颐轩电子科技有限公司官网",
			  },
			},
			{
			  path: '/customer/customerCase',
			  name:'customerCase',
			   component: () => import('@/views/customer/case/index.vue'),
			  meta:{
			  	// title:"客户案例",
				title:"广州市科颐轩电子科技有限公司官网",
			  },
			},
			{
			  path: '/news/newsList',
			  name:'newsList',
			   component: () => import('@/views/news/newsList/index.vue'),
			  meta:{
			  	// title:"新闻列表",
				title:"广州市科颐轩电子科技有限公司官网",
			  },
			},
			{
			  path: '/news/newsDetail',
			  name:'newsDetail',
			  component: () => import('@/views/news/newsDetail/index.vue'),
			  meta:{
			  	title:"广州市科颐轩电子科技有限公司官网",
			  },
			},
	      ]
  }
]

const router = new VueRouter({
	// mode: "history",
  routes
})

export default router
